<!-- 院内处方流转1.0新增组件 -->
<template>
  <div>
    <div class="recipe-list" v-if="recipeList && recipeList.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多处方了" @load="onLoad">
        <recipe-item v-for="(item, key) in recipeList" :prescription="item" :key="key" />
      </van-list>
    </div>
    <p class="placeholder" v-else-if="recipeList && recipeList.length == 0">您暂时没有处方~</p>
  </div>
</template>

<script>
import RecipeItem from './components/recipeItem.vue';
export default {
  name: 'recipe-list',
  components: {
    RecipeItem
  },
  data() {
    return {
      recipeList: null,
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20
    };
  },
  async created() {
    await this.onLoad();
  },

  methods: {
    toDetail(recipe) {},
    async onLoad() {
      await this.fetchData();
      this.loading = false;
      this.pageNo += 1;
    },
    async fetchData() {
      const { prescriptionModelDetails, totalCount } = await this.$fetch.getRecipeList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      // 放在这里避免先出现暂无处方的提示
      if (this.pageNo === 1) {
        this.recipeList = [];
      }
      if (prescriptionModelDetails) this.recipeList.push(...prescriptionModelDetails);
      if (totalCount <= this.pageNo * this.pageSize) {
        this.finished = true;
      }
    }
  }
};
</script>

